import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { AutomotiveAftermarketProfileEndpoint } from '../constants/automotive-aftermarket-profile-endpoint';
import { AutomotiveAftermarketProfileReport } from '../models/automotive-aftermarket-report.model';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketReportService {
  constructor(private http: WrapperHttpService) {}

  getReport(): Observable<AutomotiveAftermarketProfileReport> {
    const url = `${API_URL}${AutomotiveAftermarketProfileEndpoint.Base}${AutomotiveAftermarketProfileEndpoint.Profiles}${AutomotiveAftermarketProfileEndpoint.Report}${AutomotiveAftermarketProfileEndpoint.Fields}`;
    return this.http.withLoading().get<AutomotiveAftermarketProfileReport>(url);
  }
}
